import styled from "styled-components";

export const Main = styled.main`
  margin: auto;
  padding: 20px 0 100px;
  width: 100%;
  position: relative;
`;
